<template>
  <MyOrdersTab v-bind="{ fetchActive, fetchPast }" type="high-frequency">
    <template #no-results>
      <MyOrdersNoResults variant="high-frequency" />
    </template>

    <template #active="{ result }">
      <li
        v-for="highFrequencyOrder in getHighFrequencyOrders(result)"
        :key="highFrequencyOrder.orderId"
        data-containerid="high_frequency_orders_list_active"
      >
        <MyOrdersHighFrequencyCardActive :data="highFrequencyOrder" />
      </li>
    </template>

    <template #past="{ result }">
      <li
        v-for="highFrequencyOrder in getHighFrequencyOrders(result)"
        :key="highFrequencyOrder.orderId"
        data-containerid="high_frequency_orders_list_past"
      >
        <MyOrdersHighFrequenzyCardPast :data="highFrequencyOrder" />
      </li>
    </template>
  </MyOrdersTab>
</template>

<script lang="ts" setup>
import {
  HighFrequency_OrderStatus,
  type HighFrequencyOrdersQuery,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

const ACTIVE_STATUS = [HighFrequency_OrderStatus.Ordered, HighFrequency_OrderStatus.Printed]
const PAST_STATUS = [HighFrequency_OrderStatus.Finished, HighFrequency_OrderStatus.Cancelled]

const fetchActive = () =>
  useHighFrequencyOrders({
    licensedTerritory: useLicensedTerritory({ raw: true }),
    limit: 20,
    status: ACTIVE_STATUS,
  })

const fetchPast = () =>
  useHighFrequencyOrders({
    licensedTerritory: useLicensedTerritory({ raw: true }),
    limit: 3,
    status: PAST_STATUS,
  })

const getHighFrequencyOrders = (result: HighFrequencyOrdersQuery) => {
  if (isGraphqlSuccess(result.highFrequencyOrders)) {
    return result.highFrequencyOrders.highFrequencyOrders
  }
  return []
}
</script>
